function padTo2Digits(num: number) {
  return num.toString().padStart(2, '0');
}

/**
 * 格式化日期
 * @param date
 */
export function formatDate(date: any) {
  // 如果是字符串，转换为 Date 对象
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  // 检查是否为有效的 Date 对象
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
    return date; // 如果无效，直接返回原值
  }
  
  return (
    [
      dateObj.getFullYear(),
      padTo2Digits(dateObj.getMonth() + 1),
      padTo2Digits(dateObj.getDate()),
    ].join('-') +
    ' ' +
    [
      padTo2Digits(dateObj.getHours()),
      padTo2Digits(dateObj.getMinutes()),
      padTo2Digits(dateObj.getSeconds()),
    ].join(':')
  );
}

/**
 * 获取日期
 * @param date
 */
export function getDate(date: any) {
  const dateTime = formatDate(date);
  const [dt] = dateTime.split(' ');
  return dt;
}

/**
 * 获取时间
 * @param date
 */
export function getTime(date: any) {
  const dateTime = formatDate(date);
  const [, tm] = dateTime.split(' ');
  return tm;

}
